import React from "react";
import { ActionCardArgsType } from "./type";
import { useCopies } from "shared/hooks/useCopies";
import { getTimelineDisplayDate } from "../../util";

export default function useActionCardService(props: ActionCardArgsType) {
  const copies = useCopies();
  const dateToDisplay = React.useMemo(() => {
    return getTimelineDisplayDate({ actionObj: props.action, copies });
  }, [props.action, copies]);

  return {
    dateToDisplay
  };
}
